import { getAuthorisationHeader } from "../identity";
import getHeaders from "./getHeaders";
import getConfiguredRequest from "./getConfiguredRequest";

export default async () => {
  const authorisation = await getAuthorisationHeader();
  const headers = getHeaders(authorisation);
  const request = getConfiguredRequest();

  return { request, headers };
};
